import styled from 'styled-components';
import { servicesEnum } from './servicesEnum.js';

export const Container = styled.div`
  box-shadow: 0px 4px 4px 0px #00000040;
  padding: 25px;
  width: 92%;
  max-width: 92%;
  border-radius: 8px;
  display: flex;
  height: auto;
  flex-direction: column;

  @media screen and (max-width: 768px) {
    width: 100%;
    max-width: 100%;
    height: 50h;
    padding: 20px;
  }
`;

export const StatusMessageContainer = styled.div`
  position: absolute;
  top: -19px;
  left: 0;
  width: 100%;
  height: 23px;
  background-color: ${props =>
    props.status === 'ready' || props.status === 'expired' ? '#2274A5' : '#F2C94C'};
  z-index: 1 !important;
  border-radius: 4px 4px 0 0;
  padding-left: 8px;
  display: flex;
  align-items: center;
`;

export const StatusMessage = styled.div`
  font-family: Rubik;
  font-size: 0.625rem;
  font-weight: 500;
  color: ${props => (props.status === 'ready' || props.status === 'expired' ? '#fff' : '#000')};
`;

export const Text = styled.div`
  font-family: Rubik;
  font-size: 14px;
  font-weight: 600;
  line-height: 18.2px;
  text-align: left;
`;

export const TextCautelar = styled.div`
  padding-left: 10px;
  font-family: Rubik;
  font-size: 16px;
  font-weight: 500;
  text-align: left;
`;

export const TextInfo = styled.div`
  font-family: Rubik;
  font-size: 12px;
  font-weight: 400;
  text-align: left;
  @media screen and (max-width: 1025px) {
    text-align: center;
  }
`;

export const NormalText = styled.span`
  font-weight: normal;
`;

export const BoldText = styled.span`
  font-weight: 700;
`;

export const ValueContainer = styled.div`
  flex-direction: row;
  display: flex;
  align-items: end;
`;

export const ValueContainerCautelar = styled.div`
  flex-direction: row;
  display: flex;
  align-items: end;
`;

export const ModalTitle = styled.div`
  font-family: Roboto;
  font-size: 20px;
  font-weight: 700;
  line-height: 26px;
  text-align: center;
  width: 60%;

  @media screen and (max-width: 1025px) {
    width: 80%;
  }
`;

export const ModalTitleContainer = styled.div`
  justify-content: center;
  display: flex;
`;

export const SubTitleModal = styled.div`
  font-family: Roboto;
  font-size: 16px;
  font-weight: 400;
  line-height: 20.8px;
  text-align: center;
  width: 80%;

  @media screen and (max-width: 1025px) {
    width: 95%;
  }
`;

export const SubTitleModalContainer = styled.div`
  justify-content: center;
  display: flex;
  padding-top: 20px;
`;

export const SubTitleModalBold = styled.div`
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  line-height: 20.8px;
  text-align: center;
`;

export const ConfirmButton = styled.a`
  width: 360px;
  height: 48px;
  border-radius: 6px;
  background-color: rgba(34, 170, 82, 1);
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
`;

export const ConfirmButtonText = styled.div`
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  line-height: 26px;
  text-align: center;
  color: rgba(255, 255, 255, 1);
`;

export const ConfirmButtonContainer = styled.div`
  justify-content: center;
  display: flex;
  padding-top: 40px;
`;

export const CancelText = styled.a`
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  line-height: 26px;
  text-align: center;
  color: rgba(38, 50, 56, 1);
  text-decoration: underline;
`;

export const CancelTextContainer = styled.div`
  justify-content: center;
  display: flex;
  padding-top: 10px;
`;

export const CloseIconContainer = styled.div`
  justify-content: end;
  display: flex;
`;

export const ModalContent = styled.div`
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 10px;
`;

export const CloseIconDiv = styled.a``;

export const WaitContainer = styled.div`
  width: 121px;
  height: 30px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  border: 1px solid rgba(159, 160, 161, 1);
  border-radius: 4px;
  margin-right: 90px;

  @media screen and (max-width: 1025px) {
    margin-right: 0px;
  }
`;

export const WaitContainerDesk = styled.div`
  display: flex;
`;

export const KnowMoreContainer = styled.a`
  display: flex;
  font-size: 0.75rem;
  color: #333333;
  font-weight: 500;
  text-decoration: underline;
`;

export const WaitText = styled.div`
  font-family: Rubik;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: center;
  color: rgba(159, 160, 161, 1);
  padding-left: 5px;
`;

export const DownloadContainer = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  right: 0;
  top: 0;
  padding-right: 4px;
`;

export const DownloadText = styled.div`
  font-family: Rubik;
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  letter-spacing: 0%;
  text-align: center;
  text-decoration: underline;
  text-decoration-style: solid;
  color: #2274a5;
`;
export const ExpiredText = styled.div`
  font-family: Rubik;
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  letter-spacing: 0%;
  text-align: center;
  text-decoration: none;
  text-decoration-style: solid;
  color: #757778;
`;

export const AdditionalServiceText = styled.div`
  margin-bottom: ${props => props.mb};
  margin-top: ${props => props.mt};
`;

export const AdditionalServiceTitle = styled.div`
  font-family: Rubik;
  font-size: ${props => props.size};
  font-weight: 700;
  text-align: left;
  letter-spacing: 0%;
  color: #171c24;
`;

export const AdditionalServiceSubTitle = styled.div`
  font-family: Rubik;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  padding-top: 5px;
`;

export const AdditionalName = styled.div`
  font-family: Rubik;
  font-size: 1rem;
  font-weight: 600;
`;

export const AdditionalValue = styled.div`
  font-family: Rubik;
  font-size: 14px;
  font-weight: 300 !important;
  color: #333333;
  padding-top: 3px;
`;

export const AdditionalServiceOptionsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  width: 100%;
  padding-top: 15px;

  @media screen and (max-width: 768px) {
    margin-bottom: 15px;
    grid-template-columns: 1fr;
  }
`;

export const AdditionalServiceCard = styled.div`
  position: relative;
  margin-bottom: 20px;

  @media screen and (max-width: 768px) {
    ${props =>
      props.isOffer
        ? `
      width: 74.25px;
      height: 88px;
      margin-bottom: 15px;
      padding: 0;
    `
        : `
      width: 100%;
      margin-bottom: 15px;
      padding: 0;
    `}
  }
`;

export const AdditionalServiceOptions = styled.div`
  display: flex;
  width: 100%;
  align-items: stretch;
  padding: 4px;
  color: #333333;
  border: ${props => (props.isActive ? '1px solid #00A81F' : '1.2px solid #F3F3F3')};
  border-radius: 4px;
  background-color: ${props => (props.isActive ? '#EAFFEE' : '#fff')};
  position: relative;
  z-index: 2 !important;
  cursor: pointer;
  min-height: 80px;

  @media screen and (max-width: 768px) {
    ${props =>
      props.isOffer
        ? `
      width: 100%;
      min-width: 100%;
      padding: 0px;
      align-items: center;
      flex-direction: column;
      height: 100px;
    `
        : `
      min-width: 100%;
    `}
  }
`;

export const ValueInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  flex: 1;
  justify-content: space-between;
  margin-right: 40px;

  @media screen and (max-width: 768px) {
    ${props =>
      props.isOffer
        ? `
      margin-right: 20px;
      justify-content: center;
      display: none;
    `
        : `
      width: 100%;
      margin-right: 0px;
    `}
  }
`;

export const SelectServicesButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 0px;
`;

export const SelectServicesButton = styled.button`
  width: 360px;
  height: 48px;
  border-radius: 6px;
  background-color: ${props =>
    props.disabled ? 'rgba(34, 170, 82, 0.3)' : 'rgba(34, 170, 82, 1)'};
  color: #ffffff;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};

  @media screen and (max-width: 768px) {
    width: 100%;
    height: 46px;
    font-size: 18px;
  }
`;

export const ECVCardContainer = styled.div`
  display: flex;
  border: 1.2px solid var(--green-0160, #80d38f);
  background: var(--Temperatura-Alta-chance-02, #f5fff9);
  align-items: center;
  padding: 4px 8px 8px 8px;
  gap: 10px;
  border-radius: 4px;
  max-width: 328px;
  position: relative;
  margin-top: 10px;

  a {
    position: absolute;
    right: 8px;
  }

  @media screen and (max-width: 768px) {
    max-width: 100%;
    width: 100%;
    padding: 8px 12px 12px 12px;
  }
`;

export const ECVTitle = styled.div`
  font-family: Rubik;
  font-size: 1rem;
  font-weight: 600;
  color: #22aa52;
`;

export const ExternalServiceName = styled.div`
  display: none;
  font-family: Rubik;
  font-size: 10px;
  font-weight: 600;
  text-align: center;
  margin-top: 8px;
  color: #171c24;

  @media screen and (max-width: 768px) {
    ${props =>
      props.isOffer &&
      `
      display: block;
    `}
  }
`;

export const ServiceIcon = styled.img`
  padding-right: 8px;

  @media screen and (max-width: 768px) {
    ${props =>
      props.isOffer &&
      `
      padding-right: 0;
      margin: 0;
      width: 66px;
      height: 66px;
      margin-top: 4px;
    `}
  }
`;
